import { captureRemixErrorBoundaryError } from "@sentry/remix";
import {
  Links,
  Meta,
  MetaFunction,
  Outlet,
  Scripts,
  ScrollRestoration,
  useRouteError,
} from "@remix-run/react";
import "./global-styles.css";
import { OurErrorBoundary } from "./OurErrorBoundary";
import { useScript } from "./hooks/useScript";
import { LinksFunction } from "@remix-run/node";

export const ErrorBoundary = (params: any) => {
  const error = useRouteError();
  captureRemixErrorBoundaryError(error);

  return <OurErrorBoundary error={error} />;
};

export const links: LinksFunction = () => {
  return [
    {
      rel: "apple-touch-icon",
      sizes: "180x180",
      href: "/apple-touch-icon.png",
    },
    {
      rel: "icon",
      type: "image/png",
      sizes: "32x32",
      href: "/favicon-32x32.png",
    },
    {
      rel: "icon",
      type: "image/png",
      sizes: "16x16",
      href: "/favicon-16x16.png",
    },
    {
      rel: "manifest",
      href: "/site.webmanifest",
    },
    {
      rel: "shortcut icon",
      href: "/favicon.ico",
    },
    {
      rel: "icon",
      type: "image/png",
      sizes: "192x192",
      href: "/android-chrome-192x192.png",
    },
  ];
};

export const meta: MetaFunction = () => {
  return [
    {
      title:
        "BoostedPins: Boost your Shopify store traffic and sales with Pinterest",
    },
    {
      property: "og:title",
      content:
        "BoostedPins: Boost your Shopify store traffic and sales with Pinterest",
    },
    {
      name: "description",
      content:
        "BoostedPins: Boost your Shopify store traffic and sales with Pinterest",
    },
  ];
};

export default function App() {
  useScript("//eu.fw-cdn.com/13017383/969270.js");

  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <link rel="preconnect" href="https://cdn.shopify.com/" />
        <link
          rel="stylesheet"
          href="https://cdn.shopify.com/static/fonts/inter/v4/styles.css"
        />

        <Meta />
        <Links />
      </head>
      <body>
        <Outlet />
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}
